import Vue from "vue";
Vue.directive("onlyNum", {
  bind(el, binding, vnode) {
    const ele = el.tagName === "INPUT" ? el : el.querySelector("input");
    ele.oninput = function () {
      let val = ele.value;
      const arg = parseInt(binding.arg);
      const { max = Infinity } = binding.value || {};
      if (arg) {
        val = val.replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
        val = val.replace(/^\./g, ""); // 验证第一个字符是数字
        val = val.replace(/\.{2,}/g, "."); // 只保留第一个, 清除多余的
        val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        const reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${arg}}).*$`);
        val = val.replace(reg, "$1$2.$3"); // 只能输入三个小数
      } else {
        val = val.replace(/[^\d]/g, "");
      }
      if (val !== "") {
        if (parseFloat(val) > max) {
          val = max;
        }
        // else if (parseFloat(val) < min) {
        //   val = min;
        // }
      }
      ele.value = val;
      vnode.componentInstance.$emit("input", val);
    };
    ele.onblur = function () {
      let val = ele.value;
      const { min } = binding.value || {};
      const arg = parseInt(binding.arg);
      if (arg) {
        val = val.replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
        val = val.replace(/^\./g, ""); // 验证第一个字符是数字
        val = val.replace(/\.{2,}/g, "."); // 只保留第一个, 清除多余的
        val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        const reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${arg}}).*$`);
        val = val.replace(reg, "$1$2.$3"); // 只能输入三个小数
      } else {
        val = val.replace(/[^\d]/g, "");
      }
      if (!val) {
        val = min;
      } else if (val !== "" && min) {
        if (parseFloat(val) < min) {
          val = min;
        }
      } else if (min) {
        val = min;
      }
      // 限制最大最小值时 转字符类型，防止下面处理报错
      val = val.toString();

      // 清除小数点前多个0开头的值
      if (val.indexOf(".") !== -1) {
        let nums = val.split(".");
        val = `${Number(nums[0])}.${nums[1]}`;
      } else if (val) {
        val = Number(val).toString();
      }
      ele.value = "";
      ele.value = val;
      vnode.componentInstance.$emit("input", val);
      vnode.componentInstance.$emit("change", val);
    };
  },
  unbind(el) {
    const ele = el.tagName === "INPUT" ? el : el.querySelector("input");
    ele.oninput = ele.onblur = null;
  },
});
